import { apps, call, menu } from 'ionicons/icons';
import { Action, Reducer } from 'redux';
import { ApplicationState, AppThunkAction } from './';
import { baseUrl } from '../helpers/configHelper';
import update from 'immutability-helper';
import { Dispatch } from 'react';

export const VALIDATE_PIN_REQUEST = 'VALIDATE_PIN_REQUEST';
export const VALIDATE_PIN_SUCCESS = 'VALIDATE_PIN_SUCCESS';
export const VALIDATE_PIN_FAILURE = 'VALIDATE_PIN_FAILURE';
export const LOGGED_IN = 'LOGGED_IN';
export const RESET_MESSAGE = 'RESET_MESSAGE';
export interface LoggedInAction {
    type: typeof LOGGED_IN;
    isLoggedIn: boolean;
}

export interface ValidatePinRequestAction {
    type: typeof VALIDATE_PIN_REQUEST;
    payload: string;
}

export interface ValidatePinSuccessAction {
    type: typeof VALIDATE_PIN_SUCCESS;
    payload: { pfIdentifier: string; validatedOk: boolean };
}

export interface ValidatePinFailureAction {
    type: typeof VALIDATE_PIN_FAILURE;
    payload: string;
}
export interface ResetMessageAction {
    type: typeof RESET_MESSAGE;
    payload: string | null
}

export const validatePinRequest = (
    pin: string
): ValidatePinRequestAction => ({
    type: VALIDATE_PIN_REQUEST,
    payload: pin,
});

export const validatePinSuccess = (
    data: { pfIdentifier: string; validatedOk: boolean }
): ValidatePinSuccessAction => ({
    type: VALIDATE_PIN_SUCCESS,
    payload: data,
});

export const validatePinFailure = (
    error: string
): ValidatePinFailureAction => ({
    type: VALIDATE_PIN_FAILURE,
    payload: error,
});

export const loggedIn = (isLoggedIn: boolean): LoggedInAction => {
    localStorage.setItem('isLoggedIn', String(isLoggedIn));

    return {
        type: LOGGED_IN,
        isLoggedIn,
    };
};

export const resetMessage = (message: string): ResetMessageAction => ({
    type: RESET_MESSAGE,
    payload: message
});

export interface PinState {
    loading: boolean;
    error: string | null;
    message: string | null;
    expired: string | null;
    isLoggedIn: boolean;
}

type KnownAction =
    | ValidatePinRequestAction
    | ValidatePinSuccessAction
    | ValidatePinFailureAction
    | LoggedInAction
    | ResetMessageAction;

export const actionCreators = {
    validatePin: (pin: string): AppThunkAction<KnownAction> => (
        dispatch: Dispatch<any>,
        getState
    ) => {
        const currentPin = pin;
        dispatch(validatePinRequest(currentPin));

        fetch(`${baseUrl()}/colleague/validatecolleaguecode?code=${currentPin}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.validatedOk) {
                    dispatch(validatePinSuccess(data));
                    localStorage.setItem("pfidentifier", data?.pfIdentifier)
                    dispatch(loggedIn(true));
                    //console.log("Logging in with", data?.pfIdentifier);
                } else {
                    dispatch(validatePinFailure('Invalid code. Try again'));
                }
            })
            .catch((error) => {
                dispatch(validatePinFailure(error.message));
            });
    },
    logout: (isLoggedIn: boolean): AppThunkAction<KnownAction> => (
        dispatch: Dispatch<any>,
        getState
    ) => {
        const appState = getState();

        fetch(`${baseUrl()}/colleague/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(appState.colleague?.message)
        })
        .then((response) => response.json())
        .then((data) => {
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('pfidentifier');
            dispatch(loggedIn(false));
        })
    },
};

const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

const unloadedState: PinState = {
    loading: false,
    error: null,
    message: null,
    expired: null,
    isLoggedIn: isLoggedIn,
};

export const reducer: Reducer<PinState> = (
    state: PinState = JSON.parse(JSON.stringify(unloadedState)),
    incomingAction: Action
): PinState => {
    const action = incomingAction as KnownAction;

    const _unloadedState = JSON.parse(JSON.stringify(unloadedState));
    switch (action.type) {
        case VALIDATE_PIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case VALIDATE_PIN_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: action.payload.pfIdentifier,
            };
        case VALIDATE_PIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case LOGGED_IN:
            
            const s = {
                ...state,
                isLoggedIn: action.isLoggedIn,
            };
            //console.log("setting logged_in state", s);
            return s;
        case RESET_MESSAGE:
            localStorage.removeItem("pfidentifier");
            return {
                ...state,
                expired: action.payload,
            };
        default:
            return state;
    }
};